import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Sérieux & transparent",
    note: "Mon objectif n'est pas de vous vendre du rêve,",
    text: "mais de vous aider à voir si cette solution peut vraiment être intéressante pour vous.",
  },
  {
    num: "02",
    title: "Solutions sur mesure",
    note: "Chaque véhicule est unique.",
    text: "Cartographie réalisée sur mesure par un professionnel, adaptée à votre moteur et à votre usage réel.",
  },
  {
    num: "03",
    title: "Service de proximité",
    note: "Un interlocuteur unique, près de chez vous.",
    text: "Informations claires, intervention adaptée, et paiement en plusieurs fois possible.",
  },
];

export default function Manifesto() {
  return (
    <section className="relative py-24 sm:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-script text-2xl text-[#6EB000] mb-16"
        >
          Ma philosophie, en trois chapitres
        </motion.p>

        <div className="space-y-20 sm:space-y-28">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className={`grid lg:grid-cols-12 gap-6 items-end ${i % 2 === 1 ? "lg:text-right" : ""}`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className={`lg:col-span-4 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <span className="font-display text-[26vw] sm:text-[10rem] lg:text-[11rem] leading-[0.8] text-outline select-none block">
                  {c.num}
                </span>
              </div>
              <div className={`lg:col-span-8 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <h3 className="font-display text-4xl sm:text-6xl text-white">{c.title}</h3>
                <p className="font-script text-2xl sm:text-3xl text-[#6EB000] mt-4">{c.note}</p>
                <p className="text-white/60 mt-3 max-w-lg text-sm sm:text-base leading-relaxed lg:inline-block">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
